<!-- 
	CustomButton
	props: N/A
  	role: Public
	Called across the application for a fancy button 
-->

<template>
	<button
		class="button-wide rounded-lg m-4 px-4 py-2 bg-gray-500 text-gray-100 hover:bg-gray-800 duration-300 text-base"
	>
		<slot />
	</button>
</template>

<script>
	export default {
		name: "CustomButton",
	};
</script>

<style scoped>
	button.button-wide {
		min-width: 100px;
	}
</style>
